import React from 'react'
import CheckIcon from '@material-ui/icons/Check'
import classNames from 'classnames'
import type { ScheduleJobMember } from './types'
import type { ScheduleJobDialogClasses } from './useScheduleJobDialogStyles'

interface UserRowProps {
  classes: ScheduleJobDialogClasses
  member: ScheduleJobMember
  selected: boolean
  onToggle: () => void
}

export default function UserRow({ classes, member, selected, onToggle }: UserRowProps) {
  return (
    <div
      className={classes.userRow}
      onClick={onToggle}
      role="checkbox"
      aria-checked={selected}
      tabIndex={0}
      onKeyDown={(event) => event.key === 'Enter' && onToggle()}
    >
      <div className={classes.userRowLeft}>
        <span className={classes.userRowName}>{member.name}</span>
        {member.crewName ? (
          <span className={classes.crewBadge} style={{ backgroundColor: member.crewColor ?? '#929fb5' }}>
            {member.crewName}
          </span>
        ) : (
          <span className={classNames(classes.crewBadge, classes.unassignedBadge)}>Unassigned</span>
        )}
      </div>
      <div className={classNames(classes.checkCircle, selected && classes.checkCircleSelected)}>
        {selected && <CheckIcon style={{ fontSize: 12, color: '#fff' }} />}
      </div>
    </div>
  )
}
